import { useFeatureFlags } from "@/configs/featureFlag";
import { useSalesforceConnection } from "@/features/salesforceIntegration/hooks/useSalesforceConnection";
import { type SalesforceConnectionResponse } from "@/features/salesforceIntegration/types";

export interface UseSalesforceTransferGateResult {
  connection: SalesforceConnectionResponse | undefined;
  /** Salesforce連携UIを表示してよいか（実装計画書7.1節: hasContract && redataOnSalesforce）。 */
  showSalesforceTransfer: boolean;
}

/**
 * Salesforce連携UIの表示可否をまとめて判定する。一覧・詳細の両画面で同じ条件を使うため、
 * 片方だけ直して画面間で表示が食い違わないよう1か所に集約する。
 */
export const useSalesforceTransferGate =
  (): UseSalesforceTransferGateResult => {
    const { redataOnSalesforce } = useFeatureFlags();
    const { connection } = useSalesforceConnection({
      enabled: redataOnSalesforce === true,
    });
    const showSalesforceTransfer =
      redataOnSalesforce === true && connection?.hasContract === true;

    return { connection, showSalesforceTransfer };
  };
